<template>
	<svg
		style="height: 16px; width: 16px;"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<mask
			id="mask0_4882_1672"
			style="mask-type:alpha"
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="16"
			height="17"
		>
			<rect
				y="0.5"
				width="16"
				height="16"
				fill="#D9D9D9"
			/>
		</mask>
		<g mask="url(#mask0_4882_1672)">
			<path
				d="M5.07813 4.76146L6.94479 2.34479C7.07813 2.16701 7.23646 2.03646 7.41979 1.95312C7.60313 1.86979 7.79479 1.82812 7.99479 1.82812C8.19479 1.82812 8.38646 1.86979 8.56979 1.95312C8.75313 2.03646 8.91146 2.16701 9.04479 2.34479L10.9115 4.76146L13.7448 5.71146C14.0337 5.80035 14.2615 5.96424 14.4281 6.20312C14.5948 6.44201 14.6781 6.7059 14.6781 6.99479C14.6781 7.12813 14.6587 7.26146 14.6198 7.39479C14.5809 7.52813 14.517 7.6559 14.4281 7.77813L12.5948 10.3781L12.6615 13.1115C12.6726 13.5003 12.5448 13.8281 12.2781 14.0948C12.0115 14.3615 11.7003 14.4948 11.3448 14.4948C11.3226 14.4948 11.2003 14.4781 10.9781 14.4448L7.99479 13.6115L5.01146 14.4448C4.9559 14.467 4.89479 14.4809 4.82813 14.4865C4.76146 14.492 4.70035 14.4948 4.64479 14.4948C4.28924 14.4948 3.97812 14.3615 3.71146 14.0948C3.44479 13.8281 3.31701 13.5003 3.32813 13.1115L3.39479 10.3615L1.57813 7.77813C1.48924 7.6559 1.42535 7.52813 1.38646 7.39479C1.34757 7.26146 1.32812 7.12813 1.32812 6.99479C1.32812 6.71701 1.40868 6.45868 1.56979 6.21979C1.7309 5.9809 1.9559 5.81146 2.24479 5.71146L5.07813 4.76146ZM5.89479 5.91146L2.66146 6.97813L4.72813 9.96146L4.66146 13.1448L7.99479 12.2281L11.3281 13.1615L11.2615 9.96146L13.3281 7.01146L10.0948 5.91146L7.99479 3.16146L5.89479 5.91146Z"
				fill="currentColor"
			/>
			<path
				d="M7.48438 11.877L5.01855 12.6367L4.82715 9.79492L4.81836 9.66113L4.74414 9.55078L3.12109 7.11621L5.3125 6.47461L5.43652 6.43848L5.52734 6.34668L7.49414 4.36035L7.48438 11.877Z"
				fill="currentColor"
				stroke="currentColor"
			/>
		</g>
	</svg>
</template>
